module.exports = __webpack_public_path__ + "assets/img/DigitalPictogram_GIFT.d0cde38d.svg";